import axios from "axios";
import TabStorage from "../helper/TabStorage";
const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_REST_API_SLATTERY_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosApi.interceptors.request.use(
  (config) => {
    const token = TabStorage.getItem("authorize_slattery_api_token")
      ? TabStorage.getItem("authorize_slattery_api_token")
      : null;
    config.headers["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let token = await refreshAccessToken();
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return axios(originalRequest);
    }
    return Promise.reject(error);
  }
);
async function refreshAccessToken() {
  const request = {
    SecretKey: process.env.REACT_APP_REST_API_SLATTERY_SECRET_KEY,
  };
  var response = await axiosApi
    .post("/authorize/token", request, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res);
  if (response.status === 200) {
    TabStorage.removeItem("authorize_slattery_api_token");
    TabStorage.setItem("authorize_slattery_api_token", response.data);
    return response.data;
  }
  return null;
}
export default axiosApi;
